import React from 'react';
import { DigiLogo } from '../Icons';

interface LogoProps {
    onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ onClick }) => {
    return (
        <button
            type="button"
            data-pw={'button-app-logo'}
            className="app-logo"
            aria-label="Zur Startseite von Digital Sky"
            onClick={onClick}
        >
            <span>
                {DigiLogo ? <DigiLogo /> : <span>Logo</span>}
            </span>
        </button>
    );
};
